import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useLocales } from '@hooks/helpers/useLocales';
import { IModalComponentProps } from '@context/modal_context';
import { useUserContext } from '@hooks/context/useUserContext';
import InfoBlock from '@components/common/info_block';
import { EProductName } from '@xeppt/xeppt-sdk/types/products';

const ReplaceCardReasonModal: FC<IModalComponentProps<{ reason_id: string | number }>> = ({
    changeModalData,
    modalData
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'replace_card'
    });
    const { products, loyalty } = useUserContext();
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {t('title')}
            </Typography>
            <Typography variant="body3" alignment="center" className={styles.description}>
                Are you sure you want to deactivate your card and request a card replacement?
            </Typography>
            <InfoBlock>
                Please note: A $
                {products
                    ?.find(
                        (item) =>
                            item.level === loyalty?.level &&
                            item.name === EProductName.OrderCardReplacement
                    )
                    ?.price?.toFixed(2)}{' '}
                CAD card replacement fee will be charged from your XEPPT wallet. You’ll receive your
                new card within 9 business days.
            </InfoBlock>
        </div>
    );
};

export default ReplaceCardReasonModal;
